import { useState, useEffect } from 'react';

export const getWindowSize = () => ({
    width: typeof window !== 'undefined' ? window.innerWidth : null,
    height: typeof window !== 'undefined' ? window.innerHæeight : null,
});

export const useWindowSize = (initialSize = null) => {
    const [windowSize, setWindowSize] = useState(initialSize || getWindowSize());

    useEffect(() => {
        const onResize = () => setWindowSize(getWindowSize());
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', onResize);
        }
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', onResize);
            }
        };
    }, [setWindowSize]);

    return {
        ...windowSize,
    };
};

export default useWindowSize;
